import * as React from "react";
const SvgRightArrowIcon = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "100 50 54.3 25.72 54.3 40.05 0 40.05 0 50 0 59.95 54.3 59.95 54.3 74.28 100 50" }));
export default SvgRightArrowIcon;
